{
  "locale": "nl",
  "countries": {
    "AF": ["Islamitisch Emiraat Afghanistan", "Afghanistan"],
    "AL": ["Republiek Albanië", "Albanië"],
    "DZ": ["Democratische Volksrepubliek Algerije", "Algerije"],
    "AS": "Amerikaans-Samoa",
    "AD": ["Vorstendom Andorra", "Andorra"],
    "AO": ["Republiek Angola", "Angola"],
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua en Barbuda",
    "AR": ["Argentijnse Republiek", "Argentinië"],
    "AM": ["Republiek Armenië", "Armenië"],
    "AW": "Aruba",
    "AU": ["Gemenebest van Australië", "Australië"],
    "AT": ["Republiek Oostenrijk", "Oostenrijk"],
    "AZ": ["Republiek Azerbeidzjan", "Azerbeidzjan"],
    "BS": ["Gemenebest van de Bahama's", "Bahama's"],
    "BH": ["Koninkrijk Bahrein", "Bahrein"],
    "BD": ["Volksrepubliek Bangladesh", "Bangladesh"],
    "BB": ["Barbados", "Barbados"],
    "BY": ["Republiek Wit-Rusland", "Wit-Rusland"],
    "BE": ["Koninkrijk België", "België"],
    "BZ": ["Belize", "Belize"],
    "BJ": ["Republiek Benin", "Benin"],
    "BM": "Bermuda",
    "BT": ["Koninkrijk Bhutan", "Bhutan"],
    "BO": ["Plurinationale Staat Bolivia", "Bolivië"],
    "BA": ["Bosnië en Herzegovina", "Bosnië-Herzegovina"],
    "BW": ["Republiek Botswana", "Botswana"],
    "BV": "Bouvet Eiland",
    "BR": ["Federale Republiek Brazilië", "Brazilië"],
    "IO": "Brits Indische oceaan",
    "BN": ["Brunei Darussalam", "Brunei"],
    "BG": ["Republiek Bulgarije", "Bulgarije"],
    "BF": ["Burkina Faso", "Burkina Faso"],
    "BI": ["Republiek Burundi", "Burundi"],
    "KH": ["Koninkrijk Cambodja", "Cambodja"],
    "CM": ["Republiek Kameroen", "Kameroen"],
    "CA": "Canada",
    "CV": ["Republiek Kaapverdië", "Kaapverdië"],
    "KY": "Kaaimaneilanden",
    "CF": "Centraal-Afrikaanse Republiek",
    "TD": ["Republiek Tsjaad", "Tsjaad"],
    "CL": ["Republiek Chili", "Chili"],
    "CN": ["Volksrepubliek China", "China"],
    "CX": ["Christmaseiland", "Kersteiland"],
    "CC": "Cocoseilanden",
    "CO": ["Republiek Colombia", "Colombia"],
    "KM": ["Unie der Comoren", "Comoren"],
    "CG": ["Republiek Congo", "Congo-Brazzaville"],
    "CD": ["Democratische Republiek Congo", "Congo-Kinshasa"],
    "CK": "Cookeilanden",
    "CR": ["Republiek Costa Rica", "Costa Rica"],
    "CI": ["Republiek Ivoorkust", "Ivoorkust"],
    "HR": ["Republiek Kroatië", "Kroatië"],
    "CU": ["Republiek Cuba", "Cuba"],
    "CY": ["Republiek Cyprus", "Cyprus"],
    "CZ": ["Tsjechische Republiek", "Tsjechië"],
    "DK": ["Koninkrijk Denemarken", "Denemarken"],
    "DJ": ["Republiek Djibouti", "Djibouti"],
    "DM": ["Gemenebest Dominica", "Dominica"],
    "DO": "Dominicaanse Republiek",
    "EC": ["Republiek Ecuador", "Ecuador"],
    "EG": ["Arabische Republiek Egypte", "Egypte"],
    "SV": ["Republiek El Salvador", "El Salvador"],
    "GQ": ["Republiek Equatoriaal-Guinea", "Equatoriaal-Guinea"],
    "ER": ["Staat Eritrea", "Eritrea"],
    "EE": ["Republiek Estland", "Estland"],
    "ET": ["Federale Democratische Republiek Ethiopië", "Ethiopië"],
    "FK": "Falklandeilanden",
    "FO": "Faeröer",
    "FJ": ["Republiek Fiji", "Fiji"],
    "FI": ["Republiek Finland", "Finland"],
    "FR": ["Franse Republiek", "Frankrijk"],
    "GF": "Frans-Guyana",
    "PF": "Frans-Polynesië",
    "TF": "Franse Zuidelijke Gebieden",
    "GA": ["Republiek Gabon", "Gabon"],
    "GM": ["Republiek Gambia", "Gambia"],
    "GE": ["Georgië", "Georgië"],
    "DE": ["Bondsrepubliek Duitsland", "Duitsland"],
    "GH": ["Republiek Ghana", "Ghana"],
    "GI": "Gibraltar",
    "GR": ["Helleense Republiek", "Griekenland"],
    "GL": "Groenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": ["Republiek Guatemala", "Guatemala"],
    "GN": ["Republiek Guinee", "Guinea"],
    "GW": ["Republiek Guinee-Bissau", "Guinee-Bissau"],
    "GY": ["Coöperatieve Republiek Guyana", "Guyana"],
    "HT": ["Republiek Haïti", "Haïti"],
    "HM": "Heard en McDonaldeilanden",
    "VA": ["Vaticaanstad", "Vaticaanstad"],
    "HN": ["Republiek Honduras", "Honduras"],
    "HK": "Hong Kong",
    "HU": ["Hongaarse Republiek", "Hongarije"],
    "IS": ["IJslandse Republiek", "IJsland"],
    "IN": ["Republiek India", "India"],
    "ID": ["Republiek Indonesië", "Indonesië"],
    "IR": ["Islamitische Republiek Iran", "Iran"],
    "IQ": ["Republiek Irak", "Irak"],
    "IE": ["Ierse Republiek", "Ierland"],
    "IL": ["Staat Israël", "Israël"],
    "IT": ["Italiaanse Republiek", "Italië"],
    "JM": "Jamaica",
    "JP": "Japan",
    "JO": ["Hasjemitisch Koninkrijk Jordanië", "Jordanië"],
    "KZ": ["Republiek Kazachstan", "Kazachstan"],
    "KE": ["Republiek Kenia", "Kenia"],
    "KI": ["Republiek Kiribati", "Kiribati"],
    "KP": ["Democratische Volksrepubliek Korea", "Noord-Korea"],
    "KR": ["Republiek Korea", "Zuid-Korea"],
    "KW": ["Staat Koeweit", "Koeweit"],
    "KG": ["Kirgizische Republiek", "Kirgizië"],
    "LA": ["Lao Democratische Volksrepubliek", "Laos"],
    "LV": ["Republiek Letland", "Letland"],
    "LB": ["Libanese Republiek", "Libanon"],
    "LS": ["Koninkrijk Lesotho", "Lesotho"],
    "LR": ["Republiek Liberia", "Liberia"],
    "LY": ["Staat Libië", "Libië"],
    "LI": ["Vorstendom Liechtenstein", "Liechtenstein"],
    "LT": ["Republiek Litouwen", "Litouwen"],
    "LU": ["Groothertogdom Luxemburg", "Luxemburg"],
    "MO": "Macao",
    "MG": ["Republiek Madagaskar", "Madagaskar"],
    "MW": ["Republiek Malawi", "Malawi"],
    "MY": ["Maleisië", "Maleisië"],
    "MV": ["Republiek der Maldiven", "Maldiven"],
    "ML": ["Republiek Mali", "Mali"],
    "MT": ["Republiek Malta", "Malta"],
    "MH": ["Republiek der Marshalleilanden", "Marshalleilanden"],
    "MQ": "Martinique",
    "MR": ["Islamitische Republiek Mauritanië", "Mauritanië"],
    "MU": ["Republiek Mauritius", "Mauritius"],
    "YT": "Mayotte",
    "MX": ["Verenigde Mexicaanse Staten", "Mexico"],
    "FM": ["Federale Staten van Micronesië", "Micronesië"],
    "MD": ["Republiek Moldavië", "Moldavië"],
    "MC": ["Vorstendom Monaco", "Monaco"],
    "MN": ["Mongolië", "Mongolië"],
    "MS": "Montserrat",
    "MA": ["Koninkrijk Marokko", "Marokko"],
    "MZ": ["Republiek Mozambique", "Mozambique"],
    "MM": ["Republiek van de Unie van Myanmar", "Myanmar"],
    "NA": ["Republiek Namibië", "Namibië"],
    "NR": ["Republiek Nauru", "Nauru"],
    "NP": ["Federale Democratische Republiek Nepal", "Nepal"],
    "NL": ["Koninkrijk der Nederlanden", "Nederland"],
    "NC": ["Nieuw-Caledonië", "Nieuw-Caledonië"],
    "NZ": ["Nieuw-Zeeland", "Nieuw-Zeeland"],
    "NI": ["Republiek Nicaragua", "Nicaragua"],
    "NE": ["Republiek Niger", "Niger"],
    "NG": ["Federale Republiek Nigeria", "Nigeria"],
    "NU": "Niue",
    "NF": "Norfolk",
    "MP": "Noordelijke Marianen",
    "MK": ["Republiek Noord-Macedonië", "Noord-Macedonië"],
    "NO": ["Koninkrijk Noorwegen", "Noorwegen"],
    "OM": ["Sultanaat Oman", "Oman"],
    "PK": ["Islamitische Republiek Pakistan", "Pakistan"],
    "PW": ["Republiek Palau", "Palau"],
    "PS": ["Staat Palestina", "Palestina"],
    "PA": ["Republiek Panama", "Panama"],
    "PG": ["Onafhankelijke Staat Papoea-Nieuw-Guinea", "Papoea-Nieuw-Guinea"],
    "PY": ["Republiek Paraguay", "Paraguay"],
    "PE": ["Republiek Peru", "Peru"],
    "PH": ["Republiek der Filipijnen", "Filipijnen"],
    "PN": "Pitcairn",
    "PL": ["Republiek Polen", "Polen"],
    "PT": ["Portugese Republiek", "Portugal"],
    "PR": "Puerto Rico",
    "QA": ["Staat Qatar", "Qatar"],
    "RE": "Réunion",
    "RO": ["Roemeense Republiek", "Roemenië"],
    "RU": ["Russische Federatie", "Rusland"],
    "RW": ["Republiek Rwanda", "Rwanda"],
    "SH": "Sint-Helena",
    "KN": ["Federatie Saint Kitts en Nevis", "Saint Kitts en Nevis"],
    "LC": ["Saint Lucia", "Saint Lucia"],
    "PM": ["Saint-Pierre en Miquelon", "Saint-Pierre en Miquelon"],
    "VC": ["Saint Vincent en de Grenadines", "Saint Vincent en de Grenadines"],
    "WS": ["Onafhankelijke Staat Samoa", "Samoa"],
    "SM": ["Republiek San Marino", "San Marino"],
    "ST": [
      "Democratische Republiek São Tomé en Principe",
      "São Tomé en Principe"
    ],
    "SA": ["Koninkrijk Saudi-Arabië", "Saudi-Arabië"],
    "SN": ["Republiek Senegal", "Senegal"],
    "SC": ["Republiek der Seychellen", "Seychellen"],
    "SL": ["Republiek Sierra Leone", "Sierra Leone"],
    "SG": ["Republiek Singapore", "Singapore"],
    "SK": ["Slowaakse Republiek", "Slowakije"],
    "SI": ["Republiek Slovenië", "Slovenië"],
    "SB": ["Salomonseilanden", "Salomonseilanden"],
    "SO": ["Federale Republiek Somalië", "Somalië"],
    "ZA": ["Republiek Zuid-Afrika", "Zuid-Afrika"],
    "GS": "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
    "ES": ["Koninkrijk Spanje", "Spanje"],
    "LK": ["Democratische Socialistische Republiek Sri Lanka", "Sri Lanka"],
    "SD": ["Republiek Soedan", "Soedan"],
    "SR": ["Republiek Suriname", "Suriname"],
    "SJ": "Spitsbergen en Jan Mayen",
    "SZ": ["Koninkrijk Eswatini", "Eswatini", "Swaziland"],
    "SE": ["Koninkrijk Zweden", "Zweden"],
    "CH": ["Zwitserse Bondsstaat", "Zwitserland"],
    "SY": ["Syrische Arabische Republiek", "Syrië"],
    "TW": ["Taiwan", "Taiwan"],
    "TJ": ["Republiek Tadzjikistan", "Tadzjikistan"],
    "TZ": ["Verenigde Republiek Tanzania", "Tanzania"],
    "TH": ["Koninkrijk Thailand", "Thailand"],
    "TL": ["Democratische Republiek Timor-Leste", "Timor Leste"],
    "TG": ["Togolese Republiek", "Togo"],
    "TK": "Tokelau",
    "TO": ["Koninkrijk Tonga", "Tonga"],
    "TT": ["Republiek Trinidad en Tobago", "Trinidad en Tobago"],
    "TN": ["Republiek Tunesië", "Tunesië"],
    "TR": ["Republiek Turkije", "Turkije"],
    "TM": ["Turkmeense Republiek", "Turkmenistan"],
    "TC": "Turks- en Caicoseilanden",
    "TV": ["Tuvalu", "Tuvalu"],
    "UG": ["Republiek Oeganda", "Oeganda"],
    "UA": ["Oekraïne", "Oekraïne"],
    "AE": ["Verenigde Arabische Emiraten", "Verenigde Arabische Emiraten"],
    "GB": [
      "Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland",
      "Verenigd Koninkrijk"
    ],
    "US": ["Verenigde Staten van Amerika", "Verenigde Staten"],
    "UM": "Amerikaanse Kleinere Afgelegen Eilanden",
    "UY": ["Oostelijke Republiek Uruguay", "Uruguay"],
    "UZ": ["Republiek Oezbekistan", "Oezbekistan"],
    "VU": ["Republiek Vanuatu", "Vanuatu"],
    "VE": ["Bolivariaanse Republiek Venezuela", "Venezuela"],
    "VN": ["Socialistische Republiek Vietnam", "Vietnam"],
    "VG": "Britse Maagdeneilanden",
    "VI": "Amerikaanse Maagdeneilanden",
    "WF": "Wallis en Futuna",
    "EH": "Westelijke Sahara",
    "YE": ["Republiek Jemen", "Jemen"],
    "ZM": ["Republiek Zambia", "Zambia"],
    "ZW": ["Republiek Zimbabwe", "Zimbabwe"],
    "AX": "Åland",
    "BQ": "Bonaire, Sint Eustatius en Saba",
    "CW": "Curaçao",
    "GG": "Guernsey",
    "IM": "Man Eiland",
    "JE": "Jersey",
    "ME": ["Montenegro", "Montenegro"],
    "BL": "Saint Barthélemy",
    "MF": [
      "Sint-Maarten (Frans deel)",
      "Sint-Maarten (Franse Antillen)",
      "Collectiviteit van Sint-Maarten"
    ],
    "RS": ["Republiek Servië", "Servië"],
    "SX": [
      "Sint Maarten",
      "Sint-Maarten",
      "Sint Maarten (Nederlands deel)",
      "Land Sint Maarten"
    ],
    "SS": ["Republiek Zuid-Soedan", "Zuid-Soedan"],
    "XK": ["Republiek Kosovo", "Kosovo"]
  }
}
